import { Icon, IconProps } from "@chakra-ui/react";

export function EditIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6464 5.06051C15.8417 4.86525 16.1583 4.86525 16.3536 5.06051L18.9393 7.6463C19.1346 7.84156 19.1346 8.15814 18.9393 8.3534L15.9999 11.2928L12.707 7.99992L15.6464 5.06051ZM11.9999 8.70703L4.5 16.207V19.4998H7.79289L15.2928 11.9999L11.9999 8.70703ZM16.3461 12.3609L8.35355 20.3534C8.25979 20.4472 8.13261 20.4998 8 20.4998H4C3.72386 20.4998 3.5 20.276 3.5 19.9998V15.9998C3.5 15.8672 3.55268 15.7401 3.64645 15.6463L14.9393 4.3534C15.5251 3.76762 16.4749 3.76762 17.0607 4.3534L19.6464 6.93919C20.2322 7.52498 20.2322 8.47472 19.6464 9.06051L16.3609 12.3461C16.3585 12.3486 16.356 12.3511 16.3536 12.3536C16.3511 12.356 16.3486 12.3585 16.3461 12.3609Z"
        fill="currentColor"
      />
    </Icon>
  );
}
